import { render, staticRenderFns } from "./User1View.vue?vue&type=template&id=6facd4e4"
import script from "./User1View.vue?vue&type=script&lang=js"
export * from "./User1View.vue?vue&type=script&lang=js"
import style0 from "./User1View.vue?vue&type=style&index=0&id=6facd4e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports